import uuid from 'uuid'
import publicIp from 'public-ip'

const getClientIp = () => {
  return publicIp.v4()
}

function getPlugins () {
  const plugins = []
  for (let i = 0; i < navigator.plugins.length; i++) {
    const name = encodeURIComponent(navigator.plugins[i].name)
    plugins.push(name)
  }
  return plugins.join(',')
}

function getDeviceId () {
  const deviceIdKey = 'btp:deviceid'
  let deviceIdValue
  if (window.localStorage.getItem(deviceIdKey)) {
    deviceIdValue = JSON.parse(window.localStorage.getItem(deviceIdKey))
  }

  if (!deviceIdValue) {
    deviceIdValue = uuid.v4() // generate unique guid for this device
    window.localStorage.setItem(deviceIdKey, JSON.stringify(deviceIdValue))
  }

  return deviceIdValue
}
function pad (value) {
  return value < 10 ? '0' + value : value
}

function getTimeZone () {
  const date = new Date().getTimezoneOffset()
  const sign = (date > 0) ? '-' : '+'
  const offset = Math.abs(date)
  const hours = pad(Math.floor(offset / 60))
  const minutes = pad(offset % 60)
  return 'UTC' + sign + hours + ':' + minutes
}

/*
  Only works for new Microsoft Edge, Chrome and Firefox. Ie and Edge doesn't support WebRTC
*/
function getLocalIp () {
  return new Promise(resolve => {
    try {
      const PeerConnectionClass = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection

      if (!PeerConnectionClass) {
        resolve()
      }

      const peerConnection = new PeerConnectionClass({
        iceServers: []
      })

      peerConnection.createDataChannel('')
      peerConnection.createOffer(
        peerConnection.setLocalDescription.bind(peerConnection),
        () => {}
      )

      peerConnection.onicecandidate = event => {
        if (event && event.candidate && event.candidate.candidate) {
          const s = event.candidate.candidate.split(' ')
          peerConnection.onicecandidate = () => {}
          resolve(encodeURIComponent(s[4]))
        }
      }

      // in cases where onicecandidate doesn't resolve at all or fast enough...
      setTimeout(() => {
        resolve()
      }, 1000)
    } catch (e) {
      resolve()
    }
  })
}

export function getFraudHeaders (sessionStore) {
  let fraudHeaderObj = {
    'Gov-Client-Connection-Method': 'WEB_APP_VIA_SERVER',
    'Gov-Client-Device-ID': getDeviceId(),
    'Gov-Client-User-IDs': 'userId=' + sessionStore.user.id,
    'Gov-Client-Timezone': getTimeZone(),
    'Gov-Client-Screens': 'width=' + window.screen.width + '&height=' + window.screen.height +
                        '&colour-depth=' + window.screen.colorDepth + '&scaling-factor=' + window.devicePixelRatio,
    'Gov-Client-Window-Size': 'width=' + window.innerWidth + '&height=' + window.innerHeight,
    'Gov-Client-Browser-Plugins': getPlugins(),
    'Gov-Client-Browser-JS-User-Agent': navigator.userAgent,
    'Gov-Client-Browser-Do-Not-Track': navigator.doNotTrack === 1,
    // 'Gov-Client-Multi-Factor': '', // We do not use multi factor auth so leave blank, described under MTD-2139
    'Gov-Client-Local-IPs-Timestamp': new Date().toISOString()
  }
  return getLocalIp()
    .then((localIp) => {
      fraudHeaderObj['Gov-Client-Local-IPs'] = localIp || ''
      return getClientIp()
        .then((publicIpAdd) => {
          if (sessionStore.tenant === 'east_kent_college') {
            fraudHeaderObj['Gov-Client-Public-IP'] = '195.194.248.193'
          } else {
            fraudHeaderObj['Gov-Client-Public-IP'] = publicIpAdd || ''
          }
          return fraudHeaderObj
        })
    })
}
